import { defineMessages } from 'utils/intl';

export default defineMessages({
  inputQuantity: ' szt.',
});
